import { Subjects } from "../permission/constants";
import { ShirtModel } from "./ShirtModel";
import { Signature, Condition } from "../services/shirts/types";
import {
  ShirtInterface,
  ShirtOwnerInfoInterface,
} from "../services/shirts/types";

export class Shirt {
  id: number | undefined;
  title: string | undefined;
  description: string | undefined;
  purchase_date: string | undefined;
  purchase_price: string | undefined;
  current_price?: number | undefined;
  certificate: boolean;
  is_private: boolean;
  condition: Condition;
  model: ShirtModel;
  signature: Signature | undefined;
  properties: any | undefined;
  mainImage: string | undefined;
  owner: ShirtOwnerInfoInterface;
  images: Array<any>;
  irresistible_offers: boolean;
  size?: string;
  legitCheckResults?: {
    total: number;
    positive: number;
  };
  // Custom fields for when shirt was created with custom values
  team_custom?: string | undefined;
  brand_custom?: string | undefined;
  player_custom?: string | undefined;
  custom_number?: number | undefined;
  static get modelName(): string {
    return Subjects.SHIRT;
  }

  constructor(data: ShirtInterface) {
    this.id = data.id;
    this.mainImage = data.mainImage;
    this.title = data.title;
    this.description = data.description;
    this.purchase_date = data.purchase_date;
    this.purchase_price = data.purchase_price;
    this.certificate = data.certificate;
    this.is_private = data.is_private;
    this.condition = data.condition;
    this.model = new ShirtModel(data.model);
    this.signature = data.signature;
    this.properties = data.properties;
    this.owner = data.owner;
    this.images = data.images;
    this.irresistible_offers = data.irresistible_offers;
    this.current_price = data.current_price;
    this.size = data.size;
    this.legitCheckResults = data.legitCheckResults;
    this.team_custom = data.team_custom;
    this.brand_custom = data.brand_custom;
    this.player_custom = data.player_custom;
    this.custom_number = data.custom_number;
  }
}
